<template>
    <div>
        <el-dialog
            width="550px"
            title="设置答案与解析"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
        >

        <div class="subject-right">
          <!-- 单选题 -->
          <template v-if="question.questionsTypeId == 100">
            <div class="subject subject-none">
              <div class="subject-title">计分方式</div>
              <div style="display: flex; justify-content: start;align-items: center;">
                <el-select :size="'mini'"
                    :popper-append-to-body="false" @change="scoringTypeChange" v-model="question.scoringType" placeholder="请选择">
                    <el-option
                    v-for="item in scoringTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <div v-if="question.scoringType === 1" style="display: flex; margin-left: 10px;">
                    <PopoverNum
                    controls-position="right"
                    :value="question.score"
                    :size="'mini'"
                    :min="1"
                    :max="1000"
                    :content="'请输入1-1000以内的数值'"
                    @valueChange="(val) => question.score = val"
                    >
                    </PopoverNum>
                    <p style="margin-left: 10px;">分</p>
                </div> 
              </div>
            </div>
            
            <template v-if="question.scoringType === 1">
              <div class="subject subject-none">
                <div class="subject-title">答案</div>
                <el-select :size="'mini'"
                  :key="question.questionsTypeId"
                  :popper-append-to-body="false" 
                  v-model="question.answer" 
                  placeholder="请选择此题答案" 
                >
                  <el-option
                    v-for="(item) in question.optionList"
                    :key="item.oid"
                    :label="$functions.htmlFormat(item.labelName)"
                    :value="item.oid">
                    {{$functions.htmlFormat(item.labelName)}}
                  </el-option>
                </el-select>
              </div>
              <!-- <div class="subject subject-none">
                <div class="subject-title">此题分值6:</div>
                
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </div> -->
            </template>

            <template v-if="question.scoringType === 2">
              <div class="option-divst">
                <div class="option-item"  v-for="(item, index) in question.optionList" :key="index">
                    <div class="ellipsis">{{ $functions.htmlFormat(item.labelName) }}</div>
                    <!-- 选项{{index + 1}} -->
                    <div style="display: flex;">
                      <PopoverNum
                          :key="'val' + index"
                          controls-position="right"
                          :value="question.scoreArr[index]"
                          :size="'mini'"
                          :min="1"
                          :max="1000"
                          :content="'请输入1-1000以内的数值'"
                          @valueChange="(val) => optionScoreInput(val, index)"
                      >
                      </PopoverNum>
                      <p style="margin-left: 10px;">分</p>
                    </div>
                </div>
              </div>
            </template>

            <template v-if="question.scoringType === 3">
              <div class="subject subject-none">
                <div class="subject-title">此题分值5</div>
                  
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </div>
            </template>
          </template>
          <!-- 多选题 -->
          <template v-else-if="question.questionsTypeId == 101">
            <div class="subject subject-none">
              <div class="subject-title">计分方式</div>
              <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.scoringType" placeholder="请选择" :key="'scoringType2'">
                <el-option
                  v-for="item in scoringTypeList2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            
            
            <template v-if="question.scoringType === 1">
              <div class="subject subject-none">
                <div class="subject-title">答案</div>
                <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.answer" placeholder="请选择此题答案" multiple>
                  <el-option
                    v-for="(item) in question.optionList"
                    :key="item.oid"
                    :label="$functions.htmlFormat(item.labelName)"
                    :value="item.oid">
                    {{$functions.htmlFormat(item.labelName)}}
                  </el-option>
                </el-select>
              </div>
              <div class="subject subject-none">
                <div class="subject-title">此题分值4</div>
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </div>
            </template>

            <template v-if="question.scoringType === 2">
              <div class="subject subject-none">
                <div class="subject-title">答案</div>
                <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.answer" placeholder="请选择此题答案" multiple>
                  <el-option
                    v-for="(item) in question.optionList"
                    :key="item.oid"
                    :label="$functions.htmlFormat(item.labelName)"
                    :value="item.oid">
                    {{$functions.htmlFormat(item.labelName)}}
                  </el-option>
                </el-select>
              </div>
              <div class="subject subject-none">
                <div class="subject-title">少选可得分</div>
                <PopoverNum
                  controls-position="right"
                  :value="question.partialScore"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => partialScoreChange(val,question)"
                >
                </PopoverNum>
              </div>
              
              <div class="subject subject-none">
                <div class="subject-title">此题分值3</div>
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="question.partialScore"
                  :max="1000"
                  :content="`请输入${question.partialScore}-1000以内的数值`"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </div>
              
            </template>

            <template v-if="question.scoringType === 3">
              <div class="subject subject-none">
                <div class="subject-title">此题分值2</div>
                
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </div>
            </template>
          </template>
          <template v-else-if="question.questionsTypeId == 102">
            <div class="subject subject-none">
              <div class="subject-title">计分方式</div>
              <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.scoringType" placeholder="请选择" :key="'scoringType3'">
                <el-option
                  v-for="item in scoringTypeList3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div v-if="question.scoringType == 1" class="subject subject-none">
              <div class="subject-title">答案</div>
              <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.answer" placeholder="请选择此题答案" >
                <el-option
                  v-for="(item) in question.optionList"
                  :key="item.oid"
                  :label="$functions.htmlFormat(item.labelName)"
                  :value="item.oid">
                  {{$functions.htmlFormat(item.labelName)}}
                </el-option>
              </el-select>
            </div>

            <div class="subject subject-none">
              <div class="subject-title">此题分值1</div>
              <PopoverNum
                controls-position="right"
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </div>
          </template> 

          <template v-if="question.questionsTypeId == 204">
            <div class="subject subject-none">
              <div class="subject-title">计分方式1</div>
              <el-select  size="mini"
                :popper-append-to-body="false"
                v-model="question.scoringType" 
                placeholder="请选择"
              >
                <el-option
                  v-for="item in scoringTypeList4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            
            <div v-if="question.scoringType != 3" class="subject subject-none">
              <div class="subject-title">答案</div>
              <el-input  size="mini"
                type="textarea" 
                resize="none"
                :rows="4"
                maxlength="500"
                show-word-limit 
                class="keyWordInput" 
                v-model="question.answer" 
                placeholder="如果有多个标准答案，请用请用“;”隔开隔开"
              ></el-input>
            </div>
            <div class="subject subject-none">
              <div class="subject-title">此题分值</div>
              <PopoverNum
                :disabled="question.scoringType == 4 && this.question.matchingType == 3"
                controls-position="right"
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </div>
          </template>
          <template v-else-if="question.questionsTypeId == 206">
            <div class="subject subject-none">
              <div class="subject-title">计分方式2</div>
              <el-select  size="mini"
                :popper-append-to-body="false"
                v-model="question.scoringType" placeholder="请选择">
                <el-option
                  v-for="(item,index) in scoringTypeList5"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select style="margin-left: 10px;" v-if="question.scoringType == 4"  size="mini"
                :popper-append-to-body="false" 
                v-model="question.matchingType" 
                placeholder="请选择"
                @change="keyWordBlur"
                >
                <el-option
                  v-for="(item,index) in scoringTypeList6"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- <div v-if="question.scoringType == 4" class="subject subject-none">
              
            </div> -->
            <template v-if="question.scoringType != 3">
              <div class="subject subject-none">
                <div class="subject-title">关键词</div>
                <el-input  size="mini"
                  type="textarea" 
                  resize="none"
                  :rows="4"
                  maxlength="500"
                  show-word-limit 
                  class="keyWordInput" 
                  v-model="question.answer" 
                  placeholder="关键词请用分号隔开;"
                  @blur="keyWordBlur"
                ></el-input>
              </div>
              <div v-if="question.scoringType == 4 && question.matchingType == 3" class="subject subject-none">
                <div class="subject-title">每答出一个关键词</div>
                <PopoverNum
                  :value="question.partialScore"
                  controls-position="right"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => partialScoreChange(val,question)"
                >
                </PopoverNum>
              </div>
            </template>
            
            <div class="subject subject-none">
              <div class="subject-title">此题分值</div>
              <PopoverNum
                :disabled="question.scoringType == 4 && this.question.matchingType == 3"
                controls-position="right"
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </div>
          </template>
          
          <template v-else-if="question.questionsTypeId == 207 || question.questionsTypeId == 208 ">
            <div class="subject subject-none flex-itemC-none">
              <div class="subject-title">计分方式3</div>
              <div class="itemCD">
                <el-select  size="mini"
                  :popper-append-to-body="false" 
                  @change="scoringTypeChange" v-model="question.scoringType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in scoringTypeList7"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select style="margin-left: 10px" size="mini"
                  :popper-append-to-body="false" v-if="question.scoringType != 3" v-model="question.matchingType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in scoringTypeList8"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
              
            <template v-if="question.scoringType != 3">
              <div v-for="(item, oIndex) in question.optionList" :key="item.oid">
                <div class="subject-direction subject-none">
                  <p class="ellipsis">答案-
                    <span v-if="question.questionsTypeId == 207">{{ $functions.htmlFormat(item.labelName) }}</span>
                    <span v-else-if="question.questionsTypeId == 208">填空{{oIndex + 1}}</span>
                  </p>
                  <el-input  size="mini"
                    type="textarea" 
                    resize="none"
                    :rows="4"
                    maxlength="500"
                    show-word-limit 
                    v-model="item.answer" 
                    placeholder="如果有多个标准答案，请用“;”隔开"
                  ></el-input>
                </div>
                <div v-if="question.scoringType == 2" class="subject subject-none">
                  <div class="subject-title">此项分值</div>
                    <PopoverNum
                    controls-position="right"
                    :value="item.optionScore"
                    :size="'mini'"
                    :min="1"
                    :max="1000"
                    :content="'请输入1-1000以内的数值'"
                    @valueChange="(val) => optionScoreBlur(val, oIndex)"
                  >
                  </PopoverNum>
                </div>
              </div>
            </template>
              
            <div v-if="question.scoringType != 2" class="subject subject-none">
              <div class="subject-title">此题分值</div>
              <PopoverNum
                controls-position="right"
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </div>
          </template>
          <template v-else-if="question.questionsTypeId == 209 || question.questionsTypeId == 210">
            <div class="subject subject-none">
                <div class="subject-title">计分方式</div>
                <el-select  size="mini"
                :popper-append-to-body="false" v-model="question.scoringType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in scoringTypeList9"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              
            <div class="subject subject-none">
              <div class="subject-title">此题分值</div>
              <PopoverNum
                controls-position="right"
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </div>
          </template>



          <div class="subject-daan">
            <div class="subject-title" style="margin-bottom: 8px;">答案解析（可不填）</div>
            <el-input
                v-model="question.analysis"
                placeholder="请输入内容"
                type="textarea"
                size="medium"
                resize="none"
            ></el-input>
          </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
            <el-button size="medium" @click="cancel">取 消</el-button>
            <el-button size="medium" type="primary" @click="confirm">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
// 答案与解析
import PopoverNum from "@/components/myComponents/popoverNum.vue"
export default {
    name: 'SetAnswer',
    components: {
        PopoverNum,
    },
    props: {
        data: {},
    },
    data() {
        return {
            dialogVisible: false,
            scoringTypeList: [
                {
                    value: 1,
                    label: '此题唯一答案和分值'
                },
                {
                    value: 2,
                    label: '每个选项都有对应分值'
                },
                {
                    value: 3,
                    label: '人工评分'
                }
            ],
            scoringTypeList2: [
                {
                    value: 1,
                    label: '全部答对才得分'
                },
                {
                    value: 2,
                    label: '少选可得分'
                },
                {
                    value: 3,
                    label: '人工评分'
                }
            ],
            scoringTypeList3: [
                {
                    value: 1,
                    label: '此题唯一答案和分值'
                },
                {
                    value: 3,
                    label: '人工评分'
                },
            ],
            scoringTypeList4: [
              {
                value: 1,
                label: '回答与答案相同才可得分'
              },{
                value: 2,
                label: '回答包含答案即可得分'
              },{
                value: 3,
                label: '人工评分'
              },
            ],
            scoringTypeList5: [
              {
                value: 4,
                label: '回答中包含关键词即可得分'
              },{
                value: 5,
                label: '回答与答案完全相同才可得分'
              },{
                value: 3,
                label: '人工评分'
              },
            ],
            scoringTypeList6: [
              {
                value: 3,
                label: '答出几个关键词得几分'
              },{
                value: 4,
                label: '答出全部关键词才得分'
              }
            ],
            scoringTypeList7: [
              {
                value: 1,
                label: '全部答对才得分'
              },{
                value: 2,
                label: '答对几项得几分'
              },{
                value: 3,
                label: '人工评分'
              }
            ],
            scoringTypeList8: [
              {
                value: 1,
                label: '回答与答案完全相同才得分'
              },{
                value: 2,
                label: '回答中包含答案即可得分'
              }
            ],
            scoringTypeList9: [{
                value: 3,
                label: '人工评分'
              },
            ],
            question: {}
        }
    },
    watch: {
      
      data: {
        handler(newV, oldV) {
          this.question = JSON.parse(JSON.stringify(newV));
        },
        immediate: true,
        deep: true
      }
    },
    created() {
    },
    methods: {
        confirm() {
          this.$emit('updata', this.question)
          this.dialogVisible = false
        },
        cancel() {
          this.dialogVisible = false
        },
        scoringTypeChange(){
            if (this.question.scoringType == 1) {
                if (this.question.optionList.length > 0) {
                this.question.answer = this.question.optionList[0].oid
                }
            } else {
                this.question.answer = ''
            }
            this.question.score = 5
            this.question.scoreArr = []
            if (this.question.optionList.length > 0) {
                this.question.optionList.forEach(info =>{
                this.question.scoreArr.push(5)
                })
            }
            // console.log(this.question.scoreArr)
        },
        optionScoreInput(val, index) {
            this.$set(this.question.scoreArr, index, val);
            this.question.score = Math.max(...this.question.scoreArr)
        },
        // 多选题：少选可得分
        partialScoreChange(val, question) {
            question.partialScore = val
            this.keyWordBlur()
        },
        // 简答题关键词Blur
        keyWordBlur() {
          // 答对几个关键词得几分
          if (this.question.scoringType == 4 && this.question.matchingType == 3) {
            let keyWordNum = this.question.answer.split(';').length || 0
            this.question.score = this.question.partialScore * keyWordNum
          }
        },
    }
}
</script>

<style scoped lang="scss">
.subject-right{
  overflow-y: scroll;
  max-height: 400px;
}
.subject-title{
    line-height: 24px;
}
.option-divst{    
    margin: 10px 0;
    .option-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 24px;
    }
    .option-item+.option-item{
        margin-top: 5px;
    }
}
.ellipsis {
    // overflow: hidden; /*超出部分隐藏*/
    // white-space: nowrap; /*不换行*/
    // text-overflow: ellipsis; /*超出部分省略号显示*/
    width: 65%;
    // display: -webkit-box;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 1;
    // -webkit-box-flex: 1;

    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>